import ContactRequestBrowser from 'components/admin/ContactRequests/ContactRequestBrowser.jsx'
import ContactRequestDetails from 'components/admin/ContactRequests/ContactRequestDetails.jsx'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  loadContactRequests,
  selectContactRequest,
} from 'redux/contactRequests'
import { cancelConfirm } from 'redux/navigation'
import { Grid } from 'semantic-ui-react'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadContactRequests,
      selectContactRequest,
    },
    dispatch
  )
}

class ContactRequestContainer extends React.Component {
  componentWillMount() {
    const { loadContactRequests, selectContactRequest } = this.props
    loadContactRequests()
    selectContactRequest(0)
  }

  render() {
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}
            className="stacked top up-to-computer">
            <ContactRequestBrowser />
          </Grid.Column>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={8}
            widescreen={8}>
            <ContactRequestDetails />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ContactRequestContainer = connect(mapStateToProps, mapDispatchToProps)(
  ContactRequestContainer
)
export default ContactRequestContainer



// WEBPACK FOOTER //
// ./src/containers/admin/contact_requests.jsx